export enum GlobalConstants {
  SendChatMessagesMaxChars = 160,
  minCharPatientSearch = 0,
  minCharProcedureSearch = 0,
  minCharCenterSearch = 0,
  minCharMemberSearch = 0,
  //for now
  //OrganisationId = '6cbb2927-18de-492f-913e-10d2f544c069',
  //RegionId = 'dev'
}

export enum SurveyQuestionType {
  MultipleChoice = "MultipleChoice",
  SingleChoice = "SingleChoice",
  Scale = "Scale",
  Text = "Text",
  Date = "Date",
  Number = "Number",
  FileUpload = "FileUpload",
}

export enum BusChannelFeatures {
  AftercareChatEmails = "aftercare-chat-emails",
  AftercareEmails = "aftercare-emails",
  AftercareNotificationEmails = "aftercare-notification-emails",
  AftercareSurvey = "aftercare-survey",
  AftercareChatTexts = "aftercare-chat-texts",
  AftercareNotificationTexts = "aftercare-notification-texts",
  AftercareTexts = "aftercare-texts",
  Referrals = "referrals",

  ProviderTagRecalls = "recalls",
  ProviderTagAftercare = "aftercare",
}
